import { ReactNode } from 'react';
import { AuthProvider } from 'react-oidc-context';
import { oidcConfig } from '../lib/oidcConfig';
import { User } from 'oidc-client-ts';
import { useNavigate } from 'react-router-dom';

interface LearningAuthProviderProps {
  children: ReactNode;
}

export function LearningAuthProvider({ children }: LearningAuthProviderProps) {
  const navigate = useNavigate();

  const onSigninCallback = (user: User | void) => {
    // Tenta recuperar a rota original do 'state' da requisição OIDC.
    // O 'any' é usado aqui porque o tipo de 'state' é genérico.
    const intendedPath = (user?.state as any)?.intendedPath;

    // Redireciona para a rota original ou para a home como fallback.
    // O `replace: true` evita que a página de callback (/school) fique no histórico do navegador.
    navigate(intendedPath || '/', { replace: true });
  };

  return (
    <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
      {children}
    </AuthProvider>
  );
}